<template>
  <a
    class="hash-anchor"
    :href="hash"
    @click.prevent="handleClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    hash: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick(event) {
      if (this.hash) {
        event.preventDefault();
        const targetElement = document.querySelector(this.hash);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth',
          });
          window.history.pushState(null, null, this.hash);
        }
      }
    },
  },
};
</script>
